import type { PlayableItem } from '../types';
import { PLAYBACK_GENERIC_FAILURE } from '../utils/playbackErrors';

/**
 * Shown when the `<video>` or HLS.js cannot load/play the URL (CORS, geo-block, offline, bad format, etc.).
 * We do not use `fetch` to probe or resolve redirects — that fails on many IPTV hosts without CORS headers.
 */
export const PLAYBACK_PROVIDER_BLOCKED_MESSAGE = PLAYBACK_GENERIC_FAILURE;

/** Normalize stream URL the same way as `PlayerShell` attach logic (live .ts → .m3u8). */
export function resolvePlaybackStreamUrl(item: Pick<PlayableItem, 'streamUrl' | 'isLive'>): {
  url: string;
  isHls: boolean;
} {
  let url = item.streamUrl;
  if (item.isLive && url && /\.ts(\?|$)/i.test(url)) {
    url = url.replace(/\.ts(\?|$)/i, '.m3u8$1');
  }
  const isHls = /\.m3u8(\?|$)/i.test(url) || url.includes('application/x-mpegURL');
  return { url, isHls };
}
